export default __webpack_public_path__ + "static/media/ScaleCombo.606137b4.less";